var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('loading-spinner',{attrs:{"status":_vm.$t('functional.authenticating')}}):_vm._e(),(_vm.featureEnabled('planned-maintenance'))?_c('MaintenanceScreen',{staticClass:"h-full flex items-center justify-center"}):_c('div',{attrs:{"id":"app","data-test":"main-screen"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }